import { MouseEvent } from 'react'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import { IconButton, Stack, Typography } from '@mui/material'
import { ColorIndicator } from '@ui2/display'
import { SelectIconButton } from '@ui/actions'

interface IfcTypeItemProps {
  title: string
  visible: boolean
  onToggleVisibility: () => void
  /** Receives the click event so callers can extend the selection on shift-click. */
  onClickSelect?: (event: MouseEvent<HTMLButtonElement>) => void
  bgColor?: string
}

export function IfcTypeItem({
  title,
  visible,
  onToggleVisibility,
  onClickSelect,
  bgColor,
}: IfcTypeItemProps) {
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Typography sx={{ flex: 1 }}>{title}</Typography>
      <ColorIndicator color={bgColor} />
      <IconButton onClick={onToggleVisibility} sx={{ padding: 0 }}>
        {visible ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
      </IconButton>
      <SelectIconButton
        onClick={onClickSelect}
        disabled={!onClickSelect}
        sx={{ padding: 0, '& svg': { fontSize: 20 } }}
      />
    </Stack>
  )
}
